import { render, staticRenderFns } from "./StudentDetails.vue?vue&type=template&id=6f4baa7b&scoped=true&"
import script from "./StudentDetails.vue?vue&type=script&lang=js&"
export * from "./StudentDetails.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=6f4baa7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4baa7b",
  null
  
)

export default component.exports